import * as Types from '../../.cache/__types__/index';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CreateOneTimeLoginTokenMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateOneTimeLoginTokenMutation = { __typename?: 'Mutation', createOneTimeLoginToken?: string | null };


export const CreateOneTimeLoginTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOneTimeLoginToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneTimeLoginToken"}}]}}]} as unknown as DocumentNode<CreateOneTimeLoginTokenMutation, CreateOneTimeLoginTokenMutationVariables>;